const {ITEM_TYPE, CONTENT_ACTION_NEEDED} = require('am-constants');

function checkIfItemIsUnpublished (item) {
  return ![ITEM_TYPE.SECTION, ITEM_TYPE.FOLDER].includes(item.itemTypeId) &&
    item.contentActionNeededId === CONTENT_ACTION_NEEDED.NEEDS_CONTENT;
}

export default checkIfItemIsUnpublished;
